import fetchCommonData from "./fetchCommonData"
export default (() => {
    let onloads = [], data = []
    fetchCommonData({
        url: 'https://wh12.wenhua.com.cn/',
        title: 'wh12风险控制策略终端'
    }).then(res => {
        data = res
        onloads.forEach(fn => {
            fn(res)
        })
        onloads.length = 0

        //网站title定制
        if(!document.title){
            let obj = {};
            res.forEach(item => {
                obj[item.keyname] = item.value;
            });
            document.title = obj['appShortName_29'] + obj['appFullName_29'];
        }
    })
    return  {
        onload (call) {
            if (data.length > 0) {
                call(data)
            } else {
                onloads.push(call)
            }
        }
    }
}) ()